module.exports = __webpack_public_path__ + "static/v18_1lg-0a2218a74a0ddcd6326251182d705532.jpg";